<ng-container *ngIf="data && data.type_event != 'daily'">
  <app-card-event
    *ngFor="let task of dailyTask"
    [task]="task"
    [type]="data.type_event"
  ></app-card-event>
</ng-container>

<ng-container *ngIf="data && data.type_event == 'daily'">
  <h2 mat-dialog-title>Tasks List for today</h2>
  <mat-dialog-content class="mat-typography">
    <app-card-event
      *ngFor="let task of dailyTask"
      [task]="task"
      [type]="data.type_event"
    ></app-card-event>
  </mat-dialog-content>
</ng-container>
